import {
  CreatePermissions,
  deletePermissions,
  PermissionsResponse,
  PermissionsResponseMenu,
  // PermissionsResponses,
} from "interfaces";
import { get, post, put } from "services/services.methods";
import { PermissionsPaths } from "services/services.paths";

export const getPermissionsByRoleAndMenu = async (
  idRole: number,
  idMenu: number
) => {
  const response = await get<PermissionsResponse>(
    PermissionsPaths.getByRoleAndMenu + idRole + "/" + idMenu
  );

  return response.data;
};

export const getAllPermisionsByUsers = async (user_id: number) => {
  const response = await get<PermissionsResponseMenu[]>(`${PermissionsPaths.getAllPermisesByUser}${user_id}`);

  return response;
};

// export const getAllPermisionsByUsers = async (user_id: number): Promise<PermissionsResponse> => {
//   console.log('Ingrssando a enviar id ', user_id, '\n\n\n')
//   const response = await get<PermissionsResponse[]>(`${PermissionsPaths.getAllPermisesByUser}${user_id}`);
//   console.log('respuesat de servicios ', response.data, '\n\n\n')
//   return response;
// };


export const postArrayPermissions = async (permissions: CreatePermissions) => {
  const response = await post<any>(
    PermissionsPaths.postArrayPermissions,
    permissions
  );

  return response;
};

export const deleteArrayPermissions = async (
  permissions: deletePermissions
) => {
  const response = await put<any>(
    PermissionsPaths.deleteArrayPermissions,
    permissions
  );

  return response;
};
